/**
 * Generated by orval v7.3.0 🍺
 * Do not edit manually.
 * VSD API
 * API for the Victim Services Directory (VSD) application
 * OpenAPI spec version: v1
 */

export type DraftType = (typeof DraftType)[keyof typeof DraftType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const DraftType = {
  Invoice: 100000000,
  VictimApplication: 100000001,
  WitnessApplication: 100000002,
  FamilyMemberApplication: 100000003
} as const;
